import { Descriptions, Grid, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import {
  ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragment,
  SendReportCaseV1FinanceDetailsTransactionAdhocTransaction
} from '../../../../../../generated';
import { DATE_FORMAT } from '../../../../../../constants';
import { TransactionData, TransactionsLite } from '../../../../../shared/transactions/transactions-lite';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../../../../../shared/back-button';
import utc from "dayjs/plugin/utc";
import {CertificationByApplicantLegalDisclaimer} from '../../../components/certification-by-applicant-legal-disclaimer';

dayjs.extend(utc);

const { Title } = Typography;

interface SummaryProps {
  data: ApplicantCasesSendReportArchiveSummaryContainerArchivedSendReportCaseSummaryFieldsFragment;
}

export const Summary: React.FC<SummaryProps> = (props) => {
  const navigate = useNavigate();

  // calculate total amount
  let totalSentAmount = 0;
  let totalReceivedAmount = 0;
  if (props.data?.financeDetails?.transactions) {
    const finance = props.data?.financeDetails?.transactions ?? null;
    if (finance) {
      if (finance?.adhocTransactions?.length) {
        finance?.adhocTransactions?.forEach((transaction) => {
          const amount = transaction?.amount;
          if (amount !== undefined && amount !== null) {
            if (amount > 0) {
              totalSentAmount += amount;
            } else if (amount < 0) {
              totalReceivedAmount += Math.abs(amount); // Add to total received if negative
            }
          }
        });
      }
      if (finance?.submission) {
        const submissionAmount = finance?.submission?.amount ?? 0;
        totalSentAmount += submissionAmount;
      }
    }
  }
  const submissionTransaction: SendReportCaseV1FinanceDetailsTransactionAdhocTransaction = {
    amount: props.data?.financeDetails?.transactions?.submission?.amount ?? undefined,
    reason: `Intealth Requested ${props.data?.financeDetails?.transactions?.submission?.amount} for Sending Report`,
    createdAt: props.data?.financeDetails?.transactions?.submission?.transactionReference?.completedAt,
    transactionReference: {
      referenceId: props.data?.financeDetails?.transactions?.submission?.transactionReference?.referenceId
    },
    id: props.data.id
  };

  const transactionData: TransactionData = {
    totalReceived: totalReceivedAmount,
    totalSent: totalSentAmount,
    transactionsData: [...(props.data?.financeDetails?.transactions?.adhocTransactions as SendReportCaseV1FinanceDetailsTransactionAdhocTransaction[]), ...(submissionTransaction?.amount ? [submissionTransaction] : [] )].filter(Boolean)
  };

  const screen = Grid.useBreakpoint();
  const isMobile = screen.xs;

  return (
    <div className="flex flex-col space-y-7 w-full">
      {isMobile && <BackButton onBack={() => navigate("/applicant/cases")} title="Back to Cases" />}

      <div style={{ marginTop: "20px" }}>
        <Title level={4} style={{ display: 'inline' }}>
          Send Report Case
        </Title>
      </div>
      <Descriptions layout="vertical">
        <Descriptions.Item label="Submission Date">{dayjs(props.data.submittedAt).format(DATE_FORMAT).toUpperCase()}</Descriptions.Item>
        <Descriptions.Item label="Decision Date">{dayjs(props.data.caseDetails.applicationReview.decision.completedAt).format(DATE_FORMAT).toUpperCase()}</Descriptions.Item>
        <Descriptions.Item label="Case ID">{props.data.id}</Descriptions.Item>
        <Descriptions.Item label="Decision">{props.data.caseDetails.applicationReview.decision.result}</Descriptions.Item>
      </Descriptions>
      <div>
        <Title level={5}>Credential for which you want to send a Verification Status Report:</Title>
        <Descriptions layout="vertical" size="small" column={1}>
          <Descriptions.Item>{props.data.caseDetails.application.credentialTitle}</Descriptions.Item>
        </Descriptions>
      </div>
      <div>
        <Title level={5}>Recipient for the Verification Status Report:</Title>
        <Descriptions layout="vertical" size="small" column={1}>
          <Descriptions.Item>{props.data.caseDetails.application.destinationName}</Descriptions.Item>
        </Descriptions>
      </div>
      <div><CertificationByApplicantLegalDisclaimer completed={true} /></div>
      <div>
        <TransactionsLite data={transactionData} />
      </div>
    </div>
  );
};
